(() => {
  const bindBackToTop = () => {
    document.querySelectorAll('[data-mb-back-to-top]').forEach((link) => {
      if (link.dataset.mbBound) return;
      link.dataset.mbBound = 'true';
      const syncVisibility = () => { link.hidden = window.scrollY < window.innerHeight; };
      let scheduled = false;
      const scheduleUpdate = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => { scheduled = false; syncVisibility(); });
      };
      syncVisibility();
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        document.getElementById('MainContent')?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBackToTop, { once: true });
  else bindBackToTop();
  document.addEventListener('shopify:section:load', bindBackToTop);
})();
